import { useQuery } from "@tanstack/react-query";
import {
  getQuarterlyGoals,
  getAnnualGoals,
  getTrueNorth,
} from "../services/api";

export const useGetQuarterlyGoals = (quarter: string) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: ["get-quarterly-goals", quarter],
    queryFn: async () => {
      const response = await getQuarterlyGoals(quarter);
      return response;
    },
  });
  const goals = data?.data?.data;

  return { goals, isPending, isError, error };
};

export const useGetAnnualGoals = () => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: ["get-annual-goals"],
    queryFn: async () => {
      const response = await getAnnualGoals();
      return response;
    },
  });
  const goals = data?.data?.data;

  return { goals, isPending, isError, error };
};

export const useGetTrueNorth = () => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: ["get-true-north"],
    queryFn: async () => {
      const response = await getTrueNorth();
      return response;
    },
  });
  const goals = data?.data?.data;

  return { goals, isPending, isError, error };
};
